import {PumpSensorModel} from './pump-sensor-model';

export class PumpSensorHelperModel extends PumpSensorModel {
}
